import React, { PureComponent } from 'react';
import { helpers } from '@simplybenefits/sb-utils';
import Text from '../../../../components/Text.js';
class BenefitPremiumRow extends PureComponent {
  render() {
    if (!this.props.benefit) {
      return null;
    }
    const styles = {
      rowCondensed: {
        display: 'flex',
        flex: 1,
        flexDirection: 'row',
        padding: "5px 8px"
      }
    };
    const {
      benefit,
      title
    } = this.props;
    const adjustments = !benefit.adjustments ? 0 : benefit.adjustments instanceof Object ? benefit.adjustments.net : benefit.adjustments;
    return /*#__PURE__*/React.createElement("div", {
      style: styles.rowCondensed
    }, /*#__PURE__*/React.createElement(Text, {
      small: true,
      bold: true,
      customStyle: {
        flex: 2
      }
    }, title), /*#__PURE__*/React.createElement(Text, {
      small: true,
      customStyle: {
        flex: 1,
        textAlign: 'center'
      }
    }, helpers.numberWithCommas(Math.ceil(benefit.volume))), /*#__PURE__*/React.createElement(Text, {
      small: true,
      customStyle: {
        flex: 1,
        textAlign: 'center'
      }
    }, helpers.formatNumber(benefit.premium, 2, true)), /*#__PURE__*/React.createElement(Text, {
      small: true,
      customStyle: {
        flex: 1,
        textAlign: 'center'
      }
    }, helpers.formatNumber(adjustments, 2, true)), /*#__PURE__*/React.createElement(Text, {
      small: true,
      bold: true,
      customStyle: {
        flex: 1,
        textAlign: 'center'
      }
    }, helpers.formatNumber(benefit.premium + adjustments, 2, true)));
  }
}
export default BenefitPremiumRow;